import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // internationalization
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import permission from './directive/permission/index.js'// v-show指令权限
Vue.use(permission)
import checkPermission from './utils/permission' // v-if指令权限
Vue.use(checkPermission)
import { parseTime, getTreeDeepArrcode, validateaccount } from './utils/index.js' // 转时间方法
Vue.prototype.$parseTime = parseTime
Vue.prototype.$validateaccount = validateaccount
Vue.prototype.$getTreeDeepArrcode = getTreeDeepArrcode
/**
 * If you don't want to use mock-server如果不想使用mock-server
 * you want to use MockJs for mock api您希望将MockJs用于模拟api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,目前MockJs将在生产环境中使用，
 * please remove it before going online! ! !
 */
// import * as mock from '../mock'
// if (process.env.NODE_ENV === 'production') {
//   mock.mockXHR()
// }

Vue.use(Element, {
  size: Cookies.get('size') || 'mini', // 设置元素-ui默认大小  原本是medium
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
